import { ViewGrantCoreBase } from "./view-grant.core.base"


export class ViewGrantCore extends ViewGrantCoreBase {

}